import React from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { FormatStrip } from './components/FormatStrip';
import { HookSection } from './components/HookSection';
import { PainSection } from './components/PainSection';
import { RevelationSection } from './components/RevelationSection';
import { FeaturedProduct } from './components/FeaturedProduct';
import { TheoryPractice } from './components/TheoryPractice';
import { BonusesSection } from './components/BonusesSection';
import { SocialProof } from './components/SocialProof';
import { ValueStack } from './components/ValueStack';
import { AfterPurchase } from './components/AfterPurchase';
import { Guarantee } from './components/Guarantee';
import { FaqSection } from './components/FaqSection';
import { FinalCta, PageFooter } from './components/FinalCta';
import { MobileCtaBar } from './components/MobileCtaBar';
export function App() {
  return <div className="min-h-full w-full bg-carbon-900 pb-20 font-sans text-paper sm:pb-0" data-id="element-0" data-mp="23ut9zyugts8o">
      <UrgencyBar data-id="element-1" data-mp="3ij65gd4jrr9g" />
      <Hero data-id="element-2" data-mp="3ijpet5g4t7bv" />
      <FormatStrip data-id="element-3" data-mp="3ii4s22026sok" />
      <main data-id="element-4" data-mp="3mlayb9n68jv1">
        <HookSection data-id="element-5" data-mp="3mkrd9k285fcs" />
        <PainSection data-id="element-6" data-mp="3mk852v2dm5by" />
        <RevelationSection data-id="element-7" data-mp="3mjpyb4i388ps" />
        <FeaturedProduct data-id="element-8" data-mp="3rc9hqi3ghy2i" />
        <TheoryPractice data-id="element-9" data-mp="3rbznujfaj6rj" />
        <BonusesSection data-id="element-10" data-mp="3rcsyvwla8ifh" />
        <SocialProof data-id="element-11" data-mp="3reltuemj9e7n" />
        <ValueStack data-id="element-12" data-mp="5or2zhbcs60" />
        <AfterPurchase data-id="element-13" data-mp="680frswe88f" />
        <Guarantee data-id="element-14" data-mp="5gfdawxfswe" />
        <FaqSection data-id="element-15" data-mp="82jt1oitsae" />
        <FinalCta data-id="element-16" data-mp="2zl3cxocsjc6w" />
      </main>
      <PageFooter data-id="element-17" data-mp="2zm4yimrfnh2v" />
      <MobileCtaBar data-id="element-18" data-mp="2zmo3z3zwcd00" />
    </div>;
}